import { render, staticRenderFns } from "./DecidedArticle.vue?vue&type=template&id=3e25edf4&"
import script from "./DecidedArticle.vue?vue&type=script&lang=js&"
export * from "./DecidedArticle.vue?vue&type=script&lang=js&"
import style0 from "./DecidedArticle.vue?vue&type=style&index=0&id=3e25edf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports